import React, {useRef} from "react";
import {Link} from "react-router-dom";
import {
	Col,
	Container,
	Row
} from "reactstrap";
import {FontAwesomeIcon as FAI} from "@fortawesome/react-fontawesome";
import {ActionButton, ModalButton} from "./Buttons";
import {compareValues} from "../../utilities/utilities";


export const ProjectList = (
	{
		projects,
		deleteProject,
		editProject,
	}
) => {
	let deleteConfirmationDialogRef = useRef(null);

	if (projects.length) {
		if (projects.length >= 2) {
			projects.sort(compareValues("creationDate"));
		}
		let fontAwesomeIcon = ["fas", "exclamation-triangle"];
		return (
			<Container
				className={"pt-2"}
				id={"tree-list"}
			>
				{projects.map((project) => {
					let {uuid, tree} = project;
					let [error, warning, reprocess] = [null, null, null];
					if (
						typeof project.error !== "undefined" &&
						project.error !== ""
					) {
						error = <FAI
							icon={fontAwesomeIcon}
							className={"me-1 text-danger"}
							title={project.error}
						/>;
					}

					if (
						typeof project.warning !== "undefined" &&
						project.warning !== ""
					) {
						warning = <FAI
							icon={fontAwesomeIcon}
							className={"me-1 text-warning"}
							title={project.warning}
						/>;
					}

					return (
						<React.Fragment key={uuid}>
							<Row>
								<Col>
									<div className={"d-flex flex-row"}>
										<div className={"me-2"}>
											{error}
											{warning}
											{reprocess}
										</div>
										<div className={"d-flex justify-content-start flex-column"}>
											<strong className={"d-block text-truncate"}>
												{project.note || null}
											</strong>
											<small>
												{tree.common}
											</small>
											<small className={"d-none d-sm-inline fst-italic"}>
												({tree.scientific})
											</small>
										</div>
									</div>
								</Col>
								<Col>
									<div className={"d-flex justify-content-end mt-1"}>
										<Link
											className={"d-flex align-items-center justify-content-center bg-primary text-white ms-1 round square"}
											title={"Calculate this tree's benefits."}
											to={`/report/individual?era=forecast&type=benefits&uuid=${uuid}`}
										>
											<FAI icon={"calculator"}/>
										</Link>
										<ActionButton
											id={`edit-${uuid}`}
											icon={"pen"}
											classNames={"ms-1 ms-sm-2 round"}
											color={"success"}
											uuid={uuid}
											onClick={editProject}
											title={"Edit this tree's information."}
										/>
										<ActionButton
											id={`delete-prompt-${uuid}`}
											icon={"trash"}
											classNames={"ms-1 ms-sm-2 round"}
											color={"danger"}
											outline={true}
											uuid={uuid}
											onClick={() => deleteConfirmationDialogRef.current.showModal()}
											title={"Remove this tree."}
										/>
										<dialog
											className={"border border-secondary rounded"}
											ref={deleteConfirmationDialogRef}
										>
											<div className={"d-flex flex-column gap-4"}>
												<div className={"d-flex flex-row gap-5 justify-content-between align-items-baseline"}>
													<p className={"mb-0"}>
														Are you sure you want to delete this {tree.common}?
													</p>
													<button
														className={"btn btn-outline-secondary"}
														onClick={() => deleteConfirmationDialogRef.current.close()}
													>
														<FAI icon={"close"}/>
													</button>
												</div>
												<div className={"d-flex gap-3 justify-content-end"}>
													<button
														className={"btn btn-outline-secondary fw-bold"}
														onClick={() => deleteConfirmationDialogRef.current.close()}
													>
														Cancel
													</button>
													<button
														className={"btn btn-danger"}
														id={`delete-${uuid}`}
														title={"Confirm removal of this tree"}
														onClick={() => deleteProject(uuid)}
													>
														<FAI icon={"trash"}/> Yes, delete this tree
													</button>
												</div>
											</div>
										</dialog>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<hr/>
								</Col>
							</Row>
						</React.Fragment>
					)
				})}
			</Container>
		)
	} else {
		return (
			<React.Fragment>
				<div className={"text-center"}>
					<h3>Add a tree first to get started!</h3>
				</div>
			</React.Fragment>
		)
	}
}
